import { Quote } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { TESTIMONIALS } from "../../data/content";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative border-t border-[#c9a24d]/25 bg-[#0a0a0a] py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            center
            overline="Client Reviews"
            title="Trusted by Toronto homeowners & developers."
          />
        </Reveal>

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="flex h-full flex-col border border-white/10 bg-[#121212] p-8 transition-colors hover:border-gold/40"
              >
                <Quote size={32} className="text-gold" strokeWidth={1.5} />
                <blockquote className="mt-6 flex-1 text-base leading-relaxed text-neutral-300">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-8 border-t border-white/10 pt-5">
                  <div className="font-display font-bold text-white">{t.name}</div>
                  <div className="mt-1 text-xs uppercase tracking-wider text-gold">
                    {t.role}
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
